<template>
	<v-expansion-panel class="my-2" active-class="aberto" flat>
		<v-expansion-panel-header class="collapse-selecionados-header" ripple>
			<h4>Histórico de Vigência</h4>
		</v-expansion-panel-header>
		<v-expansion-panel-content class="collapse-selecionados-conteudo">
			<v-data-table
				:items="prorrogacoes"
				:headers="colunas"
				:page="paginacaoInterna.page"
				:items-per-page="paginacaoInterna.rowsPerPage"
				hide-default-footer
			>
				<template #item.numeroVigencia="{ item }">
					<span>{{ item.sequencia | sequenciaFilter }}</span>
				</template>
				<template #item.inicioVigencia="{ item }">
					<span>{{ item.inicioValidade | formatDataFilter }}</span>
				</template>
				<template #item.fimVigencia="{ item }">
					<span>{{ item.fimValidade | formatDataFilter }}</span>
				</template>
				<template #item.situacao="{ item }">
					<span>{{ item.situacao | situacaoAtaProrrogadaFilter }}</span>
				</template>
				<template #item.acoes="{ item }">
					<div class="d-flex flex-row justify-end">
						<botao-tooltip
							v-if="
								item.situacao === 'ABERTO' &&
								prorrogacoes.length > 1 &&
								temPermissaoEdicao &&
								!isAtaCancelada
							"
							icone="mdi-delete"
							data-testid="excluirProrrogacao"
							v-az-auth="permissoes.ataProrrogacaoExcluir"
							cor="grey"
							texto="Excluir"
							@click="abrirOuFecharModalExclusao(item)"
						></botao-tooltip>
					</div>
				</template>
			</v-data-table>
			<paginacao-tabela
				:total-paginas="totalPages"
				:total-itens="totalElements"
				:page.sync="paginacaoInterna.page"
				:rows-per-page.sync="paginacaoInterna.rowsPerPage"
				:show-rows-per-page="false"
				@resetar-page="resetarPaginaListagem"
			></paginacao-tabela>
		</v-expansion-panel-content>

		<modal-confirmacao
			id="excluir"
			:exibir="exibirModalExclusaoProrrogacao"
			:mensagem="mensagemExclusaoProrrogacao"
			@fechar-modal="abrirOuFecharModalExclusao"
			@confirmar="excluir"
			:subtituloModal="subtituloModalExclusao"
			:tituloModal="tituloModalexclusao"
		></modal-confirmacao>
	</v-expansion-panel>
</template>
<script>
import { TabelaColunaUtils } from '@/core/utils'
import { actionTypes } from '@/core/constants'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import validacaoAta from '@/views/mixins/validacaoAta'
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import { mapState } from 'vuex'
import RoutesNames from '@/core/constants/routes-names'

export default {
	name: 'listagem-historico-vigencia',
	components: { PaginacaoTabela, ModalConfirmacao },
	filters: {
		sequenciaFilter: (item) => {
			if (!item) return ''
			return `${item}°`
		},
		situacaoAtaProrrogadaFilter: (item) => {
			if (!item) return '--------'
			return item
		},
	},
	mixins: [validacaoAta, permissoesMixin],
	props: {
		busca: {
			type: Object,
			required: true,
		},
		isAtaCancelada: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			paginacaoInterna: this.busca.paginacao,
			prorrogacoes: [],
			totalElements: 0,
			totalPages: 0,
			exibirModalExclusaoProrrogacao: false,
			mensagemExclusaoProrrogacao: 'A prorrogação excluída não poderá ser recuperada!',
			subtituloModalExclusao: 'Deseja realmente excluir?',
			tituloModalexclusao: 'Excluir',
			prorrogacaoParaExcluir: {},
			colunas: [
				new TabelaColunaUtils('Vigência', 'numeroVigencia', '25%'),
				new TabelaColunaUtils('Início Validade', 'inicioVigencia', '25%'),
				new TabelaColunaUtils('Fim Validade', 'fimVigencia', '25%'),
				new TabelaColunaUtils('Situação', 'situacao', '15%'),
				new TabelaColunaUtils('', 'acoes', '10%'),
			],
		}
	},
	computed: {
		...mapState({
			informacoesAta: (state) => state.ata.informacoesAta,
		}),
	},
	watch: {
		busca: {
			handler(novoValor) {
				this.paginacaoInterna = novoValor.paginacao
				this.carregarProrrogacoesDoProcesso()
			},
			deep: true,
		},
	},
	async mounted() {
		await this.carregarProrrogacoesDoProcesso()
	},
	methods: {
		abrirOuFecharModalExclusao(item) {
			this.prorrogacaoParaExcluir = [item]
			this.exibirModalExclusaoProrrogacao = !this.exibirModalExclusaoProrrogacao
		},
		async excluir() {
			this.exibirModalExclusaoProrrogacao = false
			await this.$store.dispatch(
				actionTypes.ATA.GESTAO_ATA.EXCLUIR_PRORROGACAO,
				this.prorrogacaoParaExcluir[0].id,
			)
			this.mostrarNotificacaoSucesso('Prorrogação excluida com sucesso!')
			this.resetarListagens()

			if (this.prorrogacaoParaExcluir[0].idAtaPrototype) {
				await this.$router.push({
					name: RoutesNames.ATA.ATA_ACESSAR_INFORMACOES_VIEW,
					params: { id: this.prorrogacaoParaExcluir[0].idAtaPrototype },
				})
			}

			location.reload()
		},
		async carregarProrrogacoesDoProcesso() {

			let { itens, totalElements, totalPages } = await this.executarSemLoading(() =>
				this.$store.dispatch(actionTypes.ATA.GESTAO_ATA.BUSCAR_LISTAGEM_HISTORICO_PRORROGACAO, this.busca),
			)

			this.prorrogacoes = itens
			this.totalElements = totalElements
			this.totalPages = totalPages
		},
		resetarListagens() {
			if (this.prorrogacoes.length === 1) this.resetarPaginaListagem()
		},
		resetarPaginaListagem() {
			this.paginacaoInterna.page = 1
		},
	},
}
</script>

<style scoped lang="stylus">
.font-size-grande
	font-size 28px !important

.texto-menu-interno
	font-size 0.8em

.list-item-height
	min-height 0 !important

.v-list-item--disabled
	cursor not-allowed !important

.numero-prorrogacao
	min-width: 300px
</style>
